import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { TestimonialsHero } from './components/TestimonialsHero';
import { PainPoints } from './components/PainPoints';
import { SystemOverview } from './components/SystemOverview';
import { TomosAccordion } from './components/TomosAccordion';
import { BonosAccordion } from './components/BonosAccordion';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingSection } from './components/PricingSection';
import { YogaTerapeutico } from './components/YogaTerapeutico';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { ComparisonTable } from './components/ComparisonTable';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    if (!(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      (window as any).fbq('init', '1904779843432668');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-yoga-purple-200 selection:text-yoga-purple-900" data-id="element-0">
      <HeroSection data-id="element-1" />
      <TestimonialsHero data-id="element-2" />
      <PainPoints data-id="element-3" />
      <SystemOverview data-id="element-4" />
      <TomosAccordion data-id="element-5" />
      <BonosAccordion data-id="element-6" />
      <CountdownTimer data-id="element-7" />
      <PricingSection data-id="element-8" />
      <YogaTerapeutico data-id="element-9" />
      <ExtendedTestimonials data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <ComparisonTable data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}